import {Component, OnInit, inject} from '@angular/core';
import {
  DomainPageSettings,
  DomainSettingKey,
  DomainStyleSettings,
} from '@gatewee/types/domain-setting';
import {SettingsService} from '@gatewee/services/core/settings.service';

@Component({
  selector: 'app-onboarding-success',
  templateUrl: './onboarding-success.component.html',
  styleUrls: ['./onboarding-success.component.css'],
  standalone: false,
})
export class OnboardingSuccessComponent implements OnInit {
  private settingsService = inject(SettingsService);

  style!: DomainStyleSettings;
  pageSettings: DomainPageSettings | null = null;

  ngOnInit(): void {
    this.style = this.settingsService.get(
      'branding',
      DomainSettingKey.STYLE,
    ) as DomainStyleSettings;

    this.pageSettings = this.settingsService.get(
      'branding',
      DomainSettingKey.PAGE,
    ) as DomainPageSettings;
  }
}
